import type { AgentStreamEvent } from "./types";

export interface StreamScriptEntry {
	deltaMs: number;
	event: AgentStreamEvent;
}

export type StreamScript = StreamScriptEntry[];

const textEncoder = new TextEncoder();

export function createMockResponse(script: StreamScript): Response {
	const timers: number[] = [];

	const stream = new ReadableStream<Uint8Array>({
		start(controller) {
			if (script.length === 0) {
				controller.close();
				return;
			}

			let cumulativeDelay = 0;
			for (const entry of script) {
				cumulativeDelay += Math.max(0, entry.deltaMs);
				const timeoutId = setTimeout(() => {
					const payload = [`data: ${JSON.stringify(entry.event)}`, "", ""].join("\n");
					controller.enqueue(textEncoder.encode(payload));
				}, cumulativeDelay);
				timers.push(Number(timeoutId));
			}

			const closeTimeout = setTimeout(() => {
				controller.close();
			}, cumulativeDelay + 5);
			timers.push(Number(closeTimeout));
		},
		cancel() {
			for (const id of timers) {
				clearTimeout(id);
			}
		},
	});

	return new Response(stream, {
		headers: { "Content-Type": "text/event-stream" },
	});
}

let cachedScript: Promise<StreamScript> | null = null;
let cachedUrl: string | null = null;

export function loadMockScript(url: string): Promise<StreamScript> {
	if (!cachedScript || cachedUrl !== url) {
		cachedUrl = url;
		cachedScript = fetch(url)
			.then((res) => {
				if (!res.ok) {
					throw new Error(`Failed to load mock stream from ${url}`);
				}
				return res.json() as Promise<StreamScript>;
			})
			.catch((error) => {
				cachedScript = null;
				throw error;
			});
	}

	return cachedScript;
}
